import { rest } from 'msw'
import { Country } from 'types/authentication/Profile'
import mockCountries from '../../../__mocks__/countries.json'

const getCountries = rest.get<Country[]>(`${API_URL}/api/country`, async (req, res, ctx) => {
  return res(ctx.json(mockCountries))
})

export const getCountriesException = rest.get(`${API_URL}/api/country`, async (req, res, ctx) =>
  res(ctx.status(404))
)

export default [getCountries, getCountriesException]
